<template>
  <div class="base" >
    <table class="numberBoard" :style="{ 'font-size': fontSize }">
      <tr v-for="row in 9" :key="row">
        <td v-for="col in 10" :key="col + (row - 1) * 10">
          <div :class="{
            specialGold: getCurrentNumber === col + (row - 1) * 10,
            specialRed:
              getDrawnNumbers.includes(col + (row - 1) * 10) &&
              getCurrentNumber !== col + (row - 1) * 10,
          }">
            {{ col + (row - 1) * 10 }}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "NinetyNumberBoard10by9",
  props: {
    fontSize: {
      default: "55x",
    },
  },
  methods: {},
  computed: {
    ...mapGetters(["getDrawnNumbers", "getCurrentNumber"]),
  },
};
</script>

<style scoped>
.base {
  padding: 0;
  border-radius: 10px;
  height: 98.8%;
}

.numberBoard {
  width: 100%;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
    -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
  backdrop-filter: blur(50.266666412353516px);
  color: white;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  text-align: center;
  font-weight: bold;
  min-height: 100% !important;
}

td {
  border: 1px solid rgba(255, 255, 255, 0.11);
  height: 42px;
  width: 80px;
  text-align: center;
  vertical-align: middle;
  border-radius: 0px;
  color: #fff;

  text-align: center;
  font-family: "Arial Rounded MT Bold";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
}

.specialGold {
  color: white;
  border-radius: 70px;
  background: linear-gradient(180deg, #efa602 0%, rgba(239, 166, 2, 0.58) 100%);
  box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
  width: 35px;
  height: 35px;
  text-align: center;
  display: inline-block;
  line-height: 35px;
}

.specialRed {
  color: white;
  border-radius: 70px;
  background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 28%) 100%);
  box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
  width: 35px;
  height: 35px;
  text-align: center;
  display: inline-block;
  line-height: 35px;
}

@media (max-width: 1024px) {
  td {
    border: 1px solid rgba(255, 255, 255, 0.11);
    height: 65px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
  }

  .specialGold {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg,
        #efa602 0%,
        rgba(239, 166, 2, 0.58) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 48px;
    height: 48px;
    text-align: center;
    display: inline-block;
    line-height: 47px;
  }

  .specialRed {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 58%) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 48px;
    height: 48px;
    text-align: center;
    display: inline-block;
    line-height: 47px;
  }
}

@media (max-width: 1270px) {
  td {
    border: 1px solid rgba(255, 255, 255, 0.11);
    height: 40px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
  }

  .specialRed {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 28%) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 33px;
    height: 33px;
    text-align: center;
    display: inline-block;
    line-height: 31px;
  }

  .specialGold {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg,
        #efa602 0%,
        rgba(239, 166, 2, 0.58) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 33px;
    height: 33px;
    text-align: center;
    display: inline-block;
    line-height: 31px;
  }
}
@media (max-width: 1281px) {
  .numberBoard {
    width: 100%;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    backdrop-filter: blur(50.266666412353516px);
    color: white;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;
    text-align: center;
    font-weight: bold;
    min-height: 100% !important;
  }

  td {
    border: 1px solid rgba(255, 255, 255, 0.11);
    height: 40px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0px;
    color: #fff;

    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
  }

  .specialGold {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #efa602 0%, rgba(239, 166, 2, 0.58) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 38px;
    height: 38px;
    text-align: center;
    display: inline-block;
    line-height: 36px;
  }

  .specialRed {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 28%) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 38px;
    height: 38px;
    text-align: center;
    display: inline-block;
    line-height: 36px;
  }
}
@media (min-width: 2100px) and (max-width: 2800px) {
  td {
    border: 1px solid rgba(255, 255, 255, 0.11);
    height: 75px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 57px;
    font-style: normal;
    font-weight: 400;
  }

  .specialRed {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 58%) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 85px;
    height: 85px;
    text-align: center;
    display: inline-block;
    line-height: 82px;
  }

  .specialGold {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #efa602 0%, rgba(239, 166, 2, 0.58) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 85px;
    height: 85px;
    text-align: center;
    display: inline-block;
    line-height: 82px;
  }

  .numberBoard {
    width: 100%;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    backdrop-filter: blur(50.266666412353516px);
    color: white;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;
    text-align: center;
    font-weight: bold;
    min-height: 63vh;
  }
}

@media (min-width: 1700px) and (max-width: 1880px) {
  td {
    border: 1px solid rgba(255, 255, 255, 0.11);
    height: 51px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0px;
    color: #fff;

    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
  }

  .specialGold {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg,
        #efa602 0%,
        rgba(239, 166, 2, 0.58) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 57px;
    height: 57px;
    text-align: center;
    display: inline-block;
    line-height: 53px;
  }

  .specialRed {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 28%) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 57px;
    height: 57px;
    text-align: center;
    display: inline-block;
    line-height: 53px;
  }

  .numberBoard {
    width: 100%;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    backdrop-filter: blur(50.266666412353516px);
    color: white;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;
    text-align: center;
    font-weight: bold;
    min-height: 63vh;
  }
}

@media (min-width: 1900px) and (max-width: 2098px) {
  td {
    border: 1px solid rgba(255, 255, 255, 0.11);
    height: 70px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 42px;
    font-style: normal;
    font-weight: 400;
  }

  .specialRed {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 58%) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 65px;
    height: 65px;
    text-align: center;
    display: inline-block;
    line-height: 64px;
  }

  .specialGold {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #efa602 0%, rgba(239, 166, 2, 0.58) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 65px;
    height: 65px;
    text-align: center;
    display: inline-block;
    line-height: 64px;
  }

  .numberBoard {
    width: 100%;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    backdrop-filter: blur(50.266666412353516px);
    color: white;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;
    text-align: center;
    font-weight: bold;
    min-height: 64vh;
  }
}

@media (min-width: 3100px) and (max-width: 3850px) {
  td {
    border: 1px solid rgba(255, 255, 255, 0.11);
    height: 75px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 84px;
    font-style: normal;
    font-weight: 400;
  }

  .specialRed {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 58%) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 135px;
    height: 135px;
    text-align: center;
    display: inline-block;
    line-height: 136px;
  }

  .specialGold {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #efa602 0%, rgba(239, 166, 2, 0.58) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 135px;
    height: 135px;
    text-align: center;
    display: inline-block;
    line-height: 136px;
  }

  .numberBoard[data-v-5f93dcd0] {
    width: 100%;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    color: white;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;
    text-align: center;
    font-weight: bold;
    min-height: 64vh;
  }
}

@media (min-width: 4850px) and (max-width: 5800px) {
  td {
    border: 1px solid rgba(255, 255, 255, 0.11);
    height: 75px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 85px;
    font-style: normal;
    font-weight: 400;
  }

  .specialRed {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 58%) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 140px;
    height: 140px;
    text-align: center;
    display: inline-block;
    line-height: 129px;
  }

  .specialGold {
    color: white;
    border-radius: 70px;
    background: linear-gradient(180deg, #efa602 0%, rgba(239, 166, 2, 0.58) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 140px;
    height: 140px;
    text-align: center;
    display: inline-block;
    line-height: 129px;
  }
}

@media (min-width: 7380px) and (max-width: 7700px) {
  td {
    border: 1px solid rgba(255, 255, 255, 0.11);
    height: 75px;
    width: 80px;
    text-align: center;
    vertical-align: middle;
    border-radius: 0px;
    color: #fff;
    text-align: center;
    font-family: "Arial Rounded MT Bold";
    font-size: 190px;
    font-style: normal;
    font-weight: 400;
  }

  .specialRed {
    color: white;
    border-radius: 50%;
    background: linear-gradient(180deg, #ef0202 0%, rgb(239 2 2 / 58%) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 280px;
    height: 280px;
    text-align: center;
    display: inline-block;
    line-height: 275px;
  }

  .specialGold {
    color: white;
    border-radius: 50%;
    background: linear-gradient(180deg, #efa602 0%, rgba(239, 166, 2, 0.58) 100%);
    box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.2);
    width: 280px;
    height: 280px;
    text-align: center;
    display: inline-block;
    line-height: 275px;
  }

  .numberBoard {
    width: 100%;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 50.267px -50.267px 50.267px 0px rgba(194, 194, 194, 0.1) inset,
      -50.267px 50.267px 50.267px 0px rgba(255, 255, 255, 0.1) inset;
    -webkit-backdrop-filter: blur(50.266666412353516px);
    backdrop-filter: blur(50.266666412353516px);
    color: white;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;
    text-align: center;
    font-weight: bold;
    min-height: 100% !important;
  }
}
</style>
